import { baseUrl } from '../../network'

export const updateAvatarUrl = baseUrl + 'api/profile/avatar'